/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} groupCreateCommentClickParams
* @property {string} origin - manage_post_ownerapp
* @property {string} userEntry - ownerapp
**/
/**
 * Name: Group -> Create Comment Click. Evid: 834.
 * Event description: Create Comment Click.

 * origin - Type: string. Desc: manage_post_ownerapp
 *
 * userEntry - Type: string. Desc: ownerapp
 * @param {groupCreateCommentClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupCreateCommentClick = function (params) {
    return { evid: 834, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupPostClickOnOptionsParams
* @property {GUID} club_id - null
* @property {GUID} clubId - null
* @property {string} container - null
* @property {string} origin - post_three_dots
* @property {string} post_id - null
* @property {string} postId - null
* @property {string} userClass - null
* @property {string} userEntry - oneapp/ site / bizmngr
**/
/**
 * Name: Group Post -> Click on options. Evid: 83.


 * club_id - Type: guid.
 *
 * clubId - Type: guid.
 *
 * container - Type: string.
 *
 * origin - Type: string. Desc: post_three_dots
 *
 * post_id - Type: string.
 *
 * postId - Type: string.
 *
 * userClass - Type: string.
 *
 * userEntry - Type: string. Desc: oneapp/ site / bizmngr
 * @param {groupPostClickOnOptionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupPostClickOnOptions = function (params) {
    return { evid: 83, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupSettingsSaveParams
* @property {boolean} display_cover - t/f
* @property {string} edit_tab - 'discussions'/'media'/'members'/'about'
* @property {GUID} group_id - id
* @property {GUID} groupId - group ID
* @property {boolean} member_toggle - bool
* @property {string} origin - save_button
* @property {boolean} show_media - bool
* @property {boolean} show_members - bool
* @property {string} tabName - 'details'/'tabs'/'permissions'
* @property {boolean} tabToggle - t/f
* @property {string} type - 'private'/'public'/'secret'
* @property {string} userEntry - bizmgr/site/members_area/oneapp
* @property {boolean} withPhoto - t/f
**/
/**
 * Name: Group -> Group Settings Save. Evid: 10.
 * Event description: saves new settings.

 * display_cover - Type: bool. Desc: t/f
 *
 * edit_tab - Type: string. Desc: 'discussions'/'media'/'members'/'about'
 *
 * group_id - Type: guid. Desc: id
 *
 * groupId - Type: guid. Desc: group ID
 *
 * member_toggle - Type: bool. Desc: bool
 *
 * origin - Type: string. Desc: save_button
 *
 * show_media - Type: bool. Desc: bool
 *
 * show_members - Type: bool. Desc: bool
 *
 * tabName - Type: string. Desc: 'details'/'tabs'/'permissions'
 *
 * tabToggle - Type: bool. Desc: t/f
 *
 * type - Type: string. Desc: 'private'/'public'/'secret'
 *
 * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp
 *
 * withPhoto - Type: bool. Desc: t/f
 * @param {groupSettingsSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupSettingsSave = function (params) {
    return { evid: 10, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} clubPostOptionsFollowPostParams
* @property {GUID} clubId - null
* @property {string} container - null
* @property {GUID} postId - null
* @property {string} userClass - null
* @property {string} value - null
**/
/**
 * Name: Club post -> options -> Follow Post. Evid: 223.


 * clubId - Type: guid.
 *
 * container - Type: string.
 *
 * postId - Type: guid.
 *
 * userClass - Type: string.
 *
 * value - Type: string.
 * @param {clubPostOptionsFollowPostParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clubPostOptionsFollowPost = function (params) {
    return { evid: 223, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsCreateGroupNavigationParams
* @property {string} button - back / next
* @property {string} origin - plus_button_new
* @property {string} screenName - privacy / access
* @property {string} userEntry - oneapp
**/
/**
 * Name: Groups -> Create Group Navigation. Evid: 836.
 * Event description: Navigation in group creation on mobile.

 * button - Type: string. Desc: back / next
 *
 * origin - Type: string. Desc: plus_button_new
 *
 * screenName - Type: string. Desc: privacy / access
 *
 * userEntry - Type: string. Desc: oneapp
 * @param {groupsCreateGroupNavigationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsCreateGroupNavigation = function (params) {
    return { evid: 836, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsCreateGroupClickParams
* @property {string} container - null
* @property {string} origin - plus_btn / empty_state_btn / settings_create_first_grp_btn / groups_templates_scr
* @property {GUID} templateId - template id
* @property {string} templateName - staff/education/family/vips/meetup/hobby or custom_group if from Create Custom button
* @property {string} userEntry - bizmgr/site/editor/oneapp
**/
/**
 * Name: Groups-> Create Group Click. Evid: 763.


 * container - Type: string.
 *
 * origin - Type: string. Desc: plus_btn / empty_state_btn / settings_create_first_grp_btn / groups_templates_scr
 *
 * templateId - Type: guid. Desc: template id
 *
 * templateName - Type: string. Desc: staff/education/family/vips/meetup/hobby or custom_group if from Create Custom button
 *
 * userEntry - Type: string. Desc: bizmgr/site/editor/oneapp
 * @param {groupsCreateGroupClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsCreateGroupClick = function (params) {
    return { evid: 763, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} changeListLayoutParams
* @property {string} layout - grid/list
**/
/**
 * Name: change list layout (deprecated). Evid: 18.
 * Event description: changed groups list layout.

 * layout - Type: string. Desc: grid/list
 * @param {changeListLayoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var changeListLayout = function (params) {
    return { evid: 18, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupFeedTopicsSelectTopicInFeedParams
* @property {GUID} groupId - group_id
* @property {string} origin - add_question_scr
* @property {string} postId - ID of the post with topic
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Group ->  Feed Topics - Select Topic in Feed. Evid: 64.
 * Event description: Group ->  Feed Topics - Select Topic in Feed.

 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: add_question_scr
 *
 * postId - Type: string. Desc: ID of the post with topic
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupFeedTopicsSelectTopicInFeedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupFeedTopicsSelectTopicInFeed = function (params) {
    return { evid: 64, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsSelectGroupFromListParams
* @property {string} componentName - (for web) groups / groups_list_widget
* @property {string} container - null
* @property {GUID} groupId - group ID
* @property {string} origin - view_btn / group_title / group_image / group_block / groups_my_group_tab_view_btn
* @property {string} pageName - (for web) from which page click was made
* @property {string} userEntry - bizmgr/site/members_area/oneapp
**/
/**
 * Name: Groups -> Open Group. Evid: 566.


 * componentName - Type: string. Desc: (for web) groups / groups_list_widget
 *
 * container - Type: string.
 *
 * groupId - Type: guid. Desc: group ID
 *
 * origin - Type: string. Desc: view_btn / group_title / group_image / group_block / groups_my_group_tab_view_btn
 *
 * pageName - Type: string. Desc: (for web) from which page click was made
 *
 * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp
 * @param {groupsSelectGroupFromListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsSelectGroupFromList = function (params) {
    return { evid: 566, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsEventsClickParams
* @property {string} buttonName - add_eventremove/add_another_event//create_event
* @property {string} origin - restrict_group_to_event
* @property {string} userEntry - bizmngr
**/
/**
 * Name: Groups Events Click. Evid: 82.


 * buttonName - Type: string. Desc: add_eventremove/add_another_event//create_event
 *
 * origin - Type: string. Desc: restrict_group_to_event
 *
 * userEntry - Type: string. Desc: bizmngr
 * @param {groupsEventsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsEventsClick = function (params) {
    return { evid: 82, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} sendEmailDigestToggleParams
* @property {string} digestToggle - enable/disable
* @property {string} origin - groups_settings_screen
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Send Email Digest Toggle. Evid: 43.
 * Event description: Send Email Digest Toggle.

 * digestToggle - Type: string. Desc: enable/disable
 *
 * origin - Type: string. Desc: groups_settings_screen
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {sendEmailDigestToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var sendEmailDigestToggle = function (params) {
    return { evid: 43, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} memberTabAdminActionDoneParams
* @property {string} action - remove_admin/remove_member/set_admin
* @property {GUID} group_id - group
* @property {string} origin - origin: dialog_screen_btn_clk
* @property {GUID} site_member_id - member id
* @property {string} userEntry - site / bizmngr
**/
/**
 * Name: Group - > member tab admin action done. Evid: 15.
 * Event description: completed admin action.

 * action - Type: string. Desc: remove_admin/remove_member/set_admin
 *
 * group_id - Type: guid. Desc: group
 *
 * origin - Type: string. Desc: origin: dialog_screen_btn_clk
 *
 * site_member_id - Type: guid. Desc: member id
 *
 * userEntry - Type: string. Desc: site / bizmngr
 * @param {memberTabAdminActionDoneParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var memberTabAdminActionDone = function (params) {
    return { evid: 15, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} clubPostOptionsClickEditParams
* @property {GUID} club_id - null
* @property {GUID} clubId - null
* @property {string} container - null
* @property {string} post_id - null
* @property {string} postId - null
* @property {GUID} saleItemId - null
* @property {string} type - null
* @property {string} userClass - null
**/
/**
 * Name: Club post -> options -> click edit. Evid: 86.


 * club_id - Type: guid.
 *
 * clubId - Type: guid.
 *
 * container - Type: string.
 *
 * post_id - Type: string.
 *
 * postId - Type: string.
 *
 * saleItemId - Type: guid.
 *
 * type - Type: string.
 *
 * userClass - Type: string.
 * @param {clubPostOptionsClickEditParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clubPostOptionsClickEdit = function (params) {
    return { evid: 86, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsAboutEditClickedParams
* @property {GUID} groupId - null
* @property {string} origin - edit_descr_link
* @property {string} userClass - owner/member
* @property {string} userEntry - site / bizmngr
**/
/**
 * Name: Group - Description - Edit clicked. Evid: 559.


 * groupId - Type: guid.
 *
 * origin - Type: string. Desc: edit_descr_link
 *
 * userClass - Type: string. Desc: owner/member
 *
 * userEntry - Type: string. Desc: site / bizmngr
 * @param {groupsAboutEditClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsAboutEditClicked = function (params) {
    return { evid: 559, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} boGroupsSettingsOpenParams
* @property {string} origin - groups_templates_scr
* @property {GUID} templateId - template id (if you have it)
* @property {string} templateName - staff/education/family/vips/meetup/hobby or custom_group if from Create Custom button
* @property {string} userEntry - bizmgr/site/editor/oneapp
**/
/**
 * Name: Groups -> Click on Template Picture (Web). Evid: 23.
 * Event description: When user clicks on one of Template Pictures on Template Screen.

 * origin - Type: string. Desc: groups_templates_scr
 *
 * templateId - Type: guid. Desc: template id (if you have it)
 *
 * templateName - Type: string. Desc: staff/education/family/vips/meetup/hobby or custom_group if from Create Custom button
 *
 * userEntry - Type: string. Desc: bizmgr/site/editor/oneapp
 * @param {boGroupsSettingsOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boGroupsSettingsOpen = function (params) {
    return { evid: 23, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsReplyToCommentClickParams
* @property {GUID} groupId - group_id
* @property {string} origin - feed_list/post
* @property {string} userEntry - site/preview/oneapp
**/
/**
 * Name: Groups - Reply to Comment Click. Evid: 40.
 * Event description: User clicked on Reply to comment in Feed.

 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: feed_list/post
 *
 * userEntry - Type: string. Desc: site/preview/oneapp
 * @param {groupsReplyToCommentClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsReplyToCommentClick = function (params) {
    return { evid: 40, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} leaveGroupClickParams
* @property {GUID} group_id - group
* @property {string} origin - leave_dialog_modal
* @property {string} userEntry - site
**/
/**
 * Name: Group page -> leave group click (dialog scr). Evid: 6.
 * Event description: user left group.

 * group_id - Type: guid. Desc: group
 *
 * origin - Type: string. Desc: leave_dialog_modal
 *
 * userEntry - Type: string. Desc: site
 * @param {leaveGroupClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var leaveGroupClick = function (params) {
    return { evid: 6, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} memberActionParams
* @property {string} action -
* @property {GUID} group_id - group_id
* @property {string} origin - about_tab_msg_clk /
* @property {GUID} site_member_id - member id
* @property {string} userEntry - site
**/
/**
 * Name: Group -> member message action. Evid: 13.
 * Event description: member message action.

 * action - Type: string.
 *
 * group_id - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: about_tab_msg_clk /
 *
 * site_member_id - Type: guid. Desc: member id
 *
 * userEntry - Type: string. Desc: site
 * @param {memberActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var memberAction = function (params) {
    return { evid: 13, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsNewAboutSeeAllMembersParams
* @property {GUID} group_id - null
* @property {GUID} instance_id - null
* @property {GUID} msid - null
* @property {string} role - null
* @property {string} roles - null
* @property {GUID} uuid - null
**/
/**
 * Name: Groups-> New about- see all members. Evid: 721.


 * group_id - Type: guid.
 *
 * instance_id - Type: guid.
 *
 * msid - Type: guid.
 *
 * role - Type: string.
 *
 * roles - Type: string.
 *
 * uuid - Type: guid.
 * @param {groupsNewAboutSeeAllMembersParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsNewAboutSeeAllMembers = function (params) {
    return { evid: 721, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupFeedTopicsAddTopicClickIntentParams
* @property {GUID} groupId - group_id
* @property {string} origin - feed_topics_scr_cta
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Group ->  Feed Topics - Add Topic Click (Intent). Evid: 61.
 * Event description: Group ->  Feed Topics - Add Topic Click (Intent).

 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: feed_topics_scr_cta
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupFeedTopicsAddTopicClickIntentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupFeedTopicsAddTopicClickIntent = function (params) {
    return { evid: 61, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupEditCoverImageActionClickParams
* @property {string} action - take_photo/ choose_from_device
* @property {GUID} groupId - group_id
* @property {GUID} msid - msid
* @property {string} origin - img_action_modal
* @property {string} userEntry - bizmngr / site / oneapp
**/
/**
 * Name: Group - Edit - Cover Image Action Click. Evid: 33.
 * Event description: Group - Edit - Cover Image Action Click.

 * action - Type: string. Desc: take_photo/ choose_from_device
 *
 * groupId - Type: guid. Desc: group_id
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: img_action_modal
 *
 * userEntry - Type: string. Desc: bizmngr / site / oneapp
 * @param {groupEditCoverImageActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupEditCoverImageActionClick = function (params) {
    return { evid: 33, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsRestrictedToEventParams
* @property {string} action - view/close
* @property {string} origin - view_event/view_events
* @property {string} userEntry - oneapp
**/
/**
 * Name: Groups -> restricted to event. Evid: 77.
 * Event description: Joining Group restricted to the event(s).

 * action - Type: string. Desc: view/close
 *
 * origin - Type: string. Desc: view_event/view_events
 *
 * userEntry - Type: string. Desc: oneapp
 * @param {groupsRestrictedToEventParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsRestrictedToEvent = function (params) {
    return { evid: 77, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} showMemberListToggleParams
* @property {string} origin - member_list_settings_scr
* @property {boolean} toggle - true/false
* @property {string} userEntry - oneapp
**/
/**
 * Name: Show Member List Toggle. Evid: 66.
 * Event description: Show Member List to all Groups Members Toggle.

 * origin - Type: string. Desc: member_list_settings_scr
 *
 * toggle - Type: bool. Desc: true/false
 *
 * userEntry - Type: string. Desc: oneapp
 * @param {showMemberListToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var showMemberListToggle = function (params) {
    return { evid: 66, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsChoseGroupsSortByParams
* @property {string} origin - popup_menu
* @property {string} sort_by - null
* @property {string} userEntry - site / bizmngr
**/
/**
 * Name: Groups: chose groups sort by. Evid: 823.


 * origin - Type: string. Desc: popup_menu
 *
 * sort_by - Type: string.
 *
 * userEntry - Type: string. Desc: site / bizmngr
 * @param {groupsChoseGroupsSortByParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsChoseGroupsSortBy = function (params) {
    return { evid: 823, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupEditSaveParams
* @property {GUID} groupId - group_id
* @property {GUID} msid - msid
* @property {string} origin - group_edit_scr
* @property {string} userEntry - bizmngr / site / oneapp
**/
/**
 * Name: Group -> Edit -> Save. Evid: 30.
 * Event description: Group -> Edit -> Save.

 * groupId - Type: guid. Desc: group_id
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: group_edit_scr
 *
 * userEntry - Type: string. Desc: bizmngr / site / oneapp
 * @param {groupEditSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupEditSave = function (params) {
    return { evid: 30, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsSendLinkToGetGroupsOnWebClickedParams
* @property {string} action - learn_more/send_link/close
* @property {string} origin - groups_list_scr / get_web_link_scr
* @property {string} userEntry - oneapp
**/
/**
 * Name: Groups - Send Link to Get Groups on Web Clicked. Evid: 53.
 * Event description: Groups - Send Link to Get Groups on Web Clicked.

 * action - Type: string. Desc: learn_more/send_link/close
 *
 * origin - Type: string. Desc: groups_list_scr / get_web_link_scr
 *
 * userEntry - Type: string. Desc: oneapp
 * @param {groupsSendLinkToGetGroupsOnWebClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsSendLinkToGetGroupsOnWebClicked = function (params) {
    return { evid: 53, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsSearchForGroupParams
* @property {string} group_name - search term
* @property {string} origin - top_panel_editbox
* @property {string} userEntry - site / bizmngr
**/
/**
 * Name: Groups -> Search for Group. Evid: 824.


 * group_name - Type: string. Desc: search term
 *
 * origin - Type: string. Desc: top_panel_editbox
 *
 * userEntry - Type: string. Desc: site / bizmngr
 * @param {groupsSearchForGroupParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsSearchForGroup = function (params) {
    return { evid: 824, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupEditMemberPermissionsToAddMembersIntentParams
* @property {GUID} groupId - group_id
* @property {string} origin - moderation_tab_plus_btn
* @property {string} userEntry - bizmngr / site / oneapp
**/
/**
 * Name: Group -> Edit Member Permissions To Add members (Intent). Evid: 51.
 * Event description: Group -> Edit Member Permissions To Add members (Intent).

 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: moderation_tab_plus_btn
 *
 * userEntry - Type: string. Desc: bizmngr / site / oneapp
 * @param {groupEditMemberPermissionsToAddMembersIntentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupEditMemberPermissionsToAddMembersIntent = function (params) {
    return { evid: 51, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupViewPrivateMembersListParams
* @property {GUID} groupId - group_id
* @property {string} origin - memebrs_list_scr
* @property {string} userEntry - oneapp/bizmngr/site
**/
/**
 * Name: Group -> View Private Members List. Evid: 57.
 * Event description: Group -> View Private Members List.

 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: memebrs_list_scr
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr/site
 * @param {groupViewPrivateMembersListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupViewPrivateMembersList = function (params) {
    return { evid: 57, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsMemberClickOnThreeDotsParams
* @property {GUID} groupId - null
* @property {GUID} memberId - null
* @property {string} memberUuid - null
**/
/**
 * Name: Groups -> member -> click on three dots. Evid: 574.


 * groupId - Type: guid.
 *
 * memberId - Type: guid.
 *
 * memberUuid - Type: string.
 * @param {groupsMemberClickOnThreeDotsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsMemberClickOnThreeDots = function (params) {
    return { evid: 574, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} shareGroupClickParams
* @property {GUID} group_id - group_id
* @property {string} origin - share_dialog_modal
* @property {string} type - 'facebook'/'twitter'/etc
* @property {string} userEntry - site
**/
/**
 * Name: Group page -> share group click (dialog scr). Evid: 5.
 * Event description: clicked on share group.

 * group_id - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: share_dialog_modal
 *
 * type - Type: string. Desc: 'facebook'/'twitter'/etc
 *
 * userEntry - Type: string. Desc: site
 * @param {shareGroupClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shareGroupClick = function (params) {
    return { evid: 5, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsCreateSelectEventParams
* @property {GUID} groupId - null
* @property {string} origin - mobile_group_creation
* @property {string} type - PRIVATE
**/
/**
 * Name: Groups -> Create -> Select Event. Evid: 79.
 * Event description: Select Event to create restricted group.

 * groupId - Type: guid. Desc: null
 *
 * origin - Type: string. Desc: mobile_group_creation
 *
 * type - Type: string. Desc: PRIVATE
 * @param {groupsCreateSelectEventParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsCreateSelectEvent = function (params) {
    return { evid: 79, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupMembershipQuestionsMembershipQuestionsScreenLoadForMemberParams
* @property {GUID} groupId - group_id
* @property {string} origin - member_questions_screen
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Group ->  Membership Questions - Membership Questions Screen Load for Member. Evid: 48.
 * Event description: Group ->  Membership Questions - Membership Questions Screen Load for Member.

 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: member_questions_screen
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupMembershipQuestionsMembershipQuestionsScreenLoadForMemberParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupMembershipQuestionsMembershipQuestionsScreenLoadForMember = function (params) {
    return { evid: 48, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} joinRestrictedGroupCheckoutParams
* @property {number} eventId - event_id or null
* @property {string} origin - place_order_button/buy_now_button
* @property {number} planID - pp_id or null
* @property {string} type - paid_plans/events
* @property {string} userEntry - livesite
**/
/**
 * Name: Join Restricted Group -> Checkout. Evid: 90.
 * Event description: Join Restricted Group -> Checkout. Last Step -> purchase of pp/event.

 * eventId - Type: numeric. Desc: event_id or null
 *
 * origin - Type: string. Desc: place_order_button/buy_now_button
 *
 * planID - Type: numeric. Desc: pp_id or null
 *
 * type - Type: string. Desc: paid_plans/events
 *
 * userEntry - Type: string. Desc: livesite
 * @param {joinRestrictedGroupCheckoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var joinRestrictedGroupCheckout = function (params) {
    return { evid: 90, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupFeedViewParams
* @property {GUID} clubId - null
* @property {string} container - null
* @property {GUID} group_id - null
* @property {boolean} has_only_auto_post - null
* @property {string} origin - discussion_tab
* @property {string} userEntry - site
* @property {string} roles - null
**/
/**
 * Name: Group Feed View. Evid: 821.


 * clubId - Type: guid.
 *
 * container - Type: string.
 *
 * group_id - Type: guid.
 *
 * has_only_auto_post - Type: bool.
 *
 * origin - Type: string. Desc: discussion_tab
 *
 * userEntry - Type: string. Desc: site
 *
 * roles - Type: string.
 * @param {groupFeedViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupFeedView = function (params) {
    return { evid: 821, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} showMemberJoinUpdateToggleParams
* @property {string} origin - manage_group_updates_scr
* @property {boolean} toggle - true/false
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Show Member Join Update Toggle. Evid: 41.
 * Event description: Show Member Join Update Toggle.

 * origin - Type: string. Desc: manage_group_updates_scr
 *
 * toggle - Type: bool. Desc: true/false
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {showMemberJoinUpdateToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var showMemberJoinUpdateToggle = function (params) {
    return { evid: 41, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} followMemberParams
* @property {string} action - follow/unfollow
* @property {GUID} group_id - group
* @property {string} origin - discussion_tab
* @property {GUID} site_member_id - site member
* @property {string} userEntry - site
**/
/**
 * Name: Group -> follow member. Evid: 12.
 * Event description: follow group member.

 * action - Type: string. Desc: follow/unfollow
 *
 * group_id - Type: guid. Desc: group
 *
 * origin - Type: string. Desc: discussion_tab
 *
 * site_member_id - Type: guid. Desc: site member
 *
 * userEntry - Type: string. Desc: site
 * @param {followMemberParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var followMember = function (params) {
    return { evid: 12, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsSelectNotificationsSettingsParams
* @property {string} click - notifications/email_notifications
* @property {GUID} groupId - guid
* @property {string} origin - group_dashboard
* @property {GUID} siteMemberId - guid
* @property {string} type - member/owner
* @property {string} userEntry - oneapp
**/
/**
 * Name: Groups-> Select Notifications Settings. Evid: 92.
 * Event description: Groups WixApp-> Select Notifications Settings.

 * click - Type: string. Desc: notifications/email_notifications
 *
 * groupId - Type: guid. Desc: guid
 *
 * origin - Type: string. Desc: group_dashboard
 *
 * siteMemberId - Type: guid. Desc: guid
 *
 * type - Type: string. Desc: member/owner
 *
 * userEntry - Type: string. Desc: oneapp
 * @param {groupsSelectNotificationsSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsSelectNotificationsSettings = function (params) {
    return { evid: 92, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsMemberRequestApproveDeclineParams
* @property {GUID} groupId - null
* @property {boolean} isAll - null
* @property {GUID} memberId - null
* @property {string} memberUuid - member ID
* @property {string} origin - user_lvl_btn
* @property {string} type - null
* @property {string} userEntry - bizmgr/site/members_area/oneapp
**/
/**
 * Name: Groups -> member request -> approve / decline. Evid: 576.


 * groupId - Type: guid.
 *
 * isAll - Type: bool.
 *
 * memberId - Type: guid.
 *
 * memberUuid - Type: string. Desc: member ID
 *
 * origin - Type: string. Desc: user_lvl_btn
 *
 * type - Type: string.
 *
 * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp
 * @param {groupsMemberRequestApproveDeclineParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsMemberRequestApproveDecline = function (params) {
    return { evid: 576, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupGroupRulesCreateRuleParams
* @property {string} fromRuleTemplate - template characteristic if from template, null if own rule (not from template)
* @property {GUID} groupId - group_id
* @property {string} origin - rule_description_scr
* @property {string} ruleDescription - rule description/ JSON
* @property {number} ruleDescLength - count of characters in the description
* @property {string} ruleTitle - rule title / JSON
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Group ->  Group Rules - Create/Save Rule. Evid: 29.
 * Event description: Group ->  Group Rules - Create Rule.

 * fromRuleTemplate - Type: string. Desc: template characteristic if from template, null if own rule (not from template)
 *
 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: rule_description_scr
 *
 * ruleDescription - Type: string. Desc: rule description/ JSON
 *
 * ruleDescLength - Type: numeric. Desc: count of characters in the description
 *
 * ruleTitle - Type: string. Desc: rule title / JSON
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupGroupRulesCreateRuleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupGroupRulesCreateRule = function (params) {
    return { evid: 29, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupMembershipQuestionsCreateQuestionParams
* @property {GUID} groupId - group_id
* @property {boolean} isRequired - true/false
* @property {string} origin - add_question_scr
* @property {string} questionId - question ID
* @property {number} questionIndex - q index
* @property {number} questionLength - count of characters in the question
* @property {string} questionText - question text/ JSON
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Group ->  Membership Questions - Create Question. Evid: 46.


 * groupId - Type: guid. Desc: group_id
 *
 * isRequired - Type: bool. Desc: true/false
 *
 * origin - Type: string. Desc: add_question_scr
 *
 * questionId - Type: string. Desc: question ID
 *
 * questionIndex - Type: numeric. Desc: q index
 *
 * questionLength - Type: numeric. Desc: count of characters in the question
 *
 * questionText - Type: string. Desc: question text/ JSON
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupMembershipQuestionsCreateQuestionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupMembershipQuestionsCreateQuestion = function (params) {
    return { evid: 46, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupMembershipQuestionsMemberSubmitCloseAnswersParams
* @property {string} action - submit/close
* @property {number} countQuestions - (on submit) count of questions submitted
* @property {GUID} groupId - group_id
* @property {string} origin - member_questions_screen
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Group ->  Membership Questions - Member Submit/Close Answers. Evid: 49.
 * Event description: Group ->  Membership Questions - Member Submit/Close Answers.

 * action - Type: string. Desc: submit/close
 *
 * countQuestions - Type: numeric. Desc: (on submit) count of questions submitted
 *
 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: member_questions_screen
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupMembershipQuestionsMemberSubmitCloseAnswersParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupMembershipQuestionsMemberSubmitCloseAnswers = function (params) {
    return { evid: 49, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupManagePostClickParams
* @property {GUID} groupId - guid
* @property {string} origin - manage_post_ownerapp
* @property {string} userEntry - ownerapp
**/
/**
 * Name: Group -> Manage Post Click. Evid: 833.
 * Event description: manage post panel inside ownerapp click.

 * groupId - Type: guid. Desc: guid
 *
 * origin - Type: string. Desc: manage_post_ownerapp
 *
 * userEntry - Type: string. Desc: ownerapp
 * @param {groupManagePostClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupManagePostClick = function (params) {
    return { evid: 833, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupOnboardingActionSkipParams
* @property {GUID} groupId - group ID
* @property {string} skippedStep - invite/add_cover/update_descr/create_post/explore_dshboard/group_ready
* @property {string} userEntry - bizmgr/site/members_area/oneapp/editor
**/
/**
 * Name: Group -> Onboarding Action Skip. Evid: 73.
 * Event description: Group -> Onboarding Action Skip.

 * groupId - Type: guid. Desc: group ID
 *
 * skippedStep - Type: string. Desc: invite/add_cover/update_descr/create_post/explore_dshboard/group_ready
 *
 * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp/editor
 * @param {groupOnboardingActionSkipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupOnboardingActionSkip = function (params) {
    return { evid: 73, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} joinRestrictedGroupParams
* @property {string} origin - group_list/join_button/discussions _tab/get_another_plan
* @property {string} type - paid_plans/events
* @property {string} userEntry - livesite
**/
/**
 * Name: Join Restricted Group. Evid: 88.
 * Event description: Join Restricted Group.

 * origin - Type: string. Desc: group_list/join_button/discussions _tab/get_another_plan
 *
 * type - Type: string. Desc: paid_plans/events
 *
 * userEntry - Type: string. Desc: livesite
 * @param {joinRestrictedGroupParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var joinRestrictedGroup = function (params) {
    return { evid: 88, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsManageGroups830Params
* @property {string} buttonName - connect_group, manage_group, disconnect etc
* @property {GUID} event_id - event ID
* @property {string} origin - admin_widget etc
* @property {string} userEntry - oneapp/bizmngr/editor etc
**/
/**
 * Name: Groups -> Manage Events Groups Button Click. Evid: 830.
 * Event description: Groups -> Manage Events Groups Button Click.

 * buttonName - Type: string. Desc: connect_group, manage_group, disconnect etc
 *
 * event_id - Type: guid. Desc: event ID
 *
 * origin - Type: string. Desc: admin_widget etc
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr/editor etc
 * @param {groupsManageGroups830Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsManageGroups830 = function (params) {
    return { evid: 830, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsPermisionForUouToCreateAGroupParams
* @property {string} origin - save_btn
* @property {string} permissions - members/owner_only/members_with_approval
* @property {boolean} toggle - null
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Groups -> permision for UoU to create a group. Evid: 604.


 * origin - Type: string. Desc: save_btn
 *
 * permissions - Type: string. Desc: members/owner_only/members_with_approval
 *
 * toggle - Type: bool.
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupsPermisionForUouToCreateAGroupParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsPermisionForUouToCreateAGroup = function (params) {
    return { evid: 604, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} memberWelcomeScreenSeeMoreClickedParams
* @property {GUID} groupId - group ID
* @property {string} userEntry - wixapp/site
**/
/**
 * Name: Member Welcome Screen - See More Clicked. Evid: 698.


 * groupId - Type: guid. Desc: group ID
 *
 * userEntry - Type: string. Desc: wixapp/site
 * @param {memberWelcomeScreenSeeMoreClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var memberWelcomeScreenSeeMoreClicked = function (params) {
    return { evid: 698, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsWelcomeToGroupsScreenLoadParams
* @property {string} userEntry - oneapp
**/
/**
 * Name: Groups - Welcome to Groups Screen Load. Evid: 55.


 * userEntry - Type: string. Desc: oneapp
 * @param {groupsWelcomeToGroupsScreenLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsWelcomeToGroupsScreenLoad = function (params) {
    return { evid: 55, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} changeListDisplayParams
* @property {string} info - member_count/group_list_title/etc
* @property {boolean} is_shown - bool
**/
/**
 * Name: change list display (deprecated). Evid: 19.
 * Event description: changed list display.

 * info - Type: string. Desc: member_count/group_list_title/etc
 *
 * is_shown - Type: bool. Desc: bool
 * @param {changeListDisplayParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var changeListDisplay = function (params) {
    return { evid: 19, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} addMemberSkipClickedParams
* @property {GUID} group_id - value
* @property {GUID} groupId - group ID
* @property {string} origin - "members_list_scr"/"inv_members_scr"
* @property {string} userEntry - oneapp
**/
/**
 * Name: Group -> Add Member Skip Clicked. Evid: 27.
 * Event description: Add Member Skip Clicked.

 * group_id - Type: guid. Desc: value
 *
 * groupId - Type: guid. Desc: group ID
 *
 * origin - Type: string. Desc: "members_list_scr"/"inv_members_scr"
 *
 * userEntry - Type: string. Desc: oneapp
 * @param {addMemberSkipClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addMemberSkipClicked = function (params) {
    return { evid: 27, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupInviteMembersOptionClickedParams
* @property {GUID} groupId - group ID
* @property {string} optionType - selected option - send_email, add_site_members, copy_link, create_email_campaign
* @property {string} origin - invite_modal
* @property {string} userEntry - oneapp/site/bizmngr
**/
/**
 * Name: Group -> Add/Invite Members Option Clicked. Evid: 74.
 * Event description: Group -> Add/Invite Members Option Clicked.

 * groupId - Type: guid. Desc: group ID
 *
 * optionType - Type: string. Desc: selected option - send_email, add_site_members, copy_link, create_email_campaign
 *
 * origin - Type: string. Desc: invite_modal
 *
 * userEntry - Type: string. Desc: oneapp/site/bizmngr
 * @param {groupInviteMembersOptionClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupInviteMembersOptionClicked = function (params) {
    return { evid: 74, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupSelectMembersListFilterParams
* @property {string} filterBy - admins, all_members, pending
* @property {GUID} groupId - group ID
* @property {string} origin - memb_list
* @property {string} userEntry - site / bizmngr / wixapp
**/
/**
 * Name: Group -> Select Members List Filter. Evid: 75.
 * Event description: Group -> Select Members List Filter.

 * filterBy - Type: string. Desc: admins, all_members, pending
 *
 * groupId - Type: guid. Desc: group ID
 *
 * origin - Type: string. Desc: memb_list
 *
 * userEntry - Type: string. Desc: site / bizmngr / wixapp
 * @param {groupSelectMembersListFilterParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupSelectMembersListFilter = function (params) {
    return { evid: 75, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupEditCloseParams
* @property {GUID} groupId - group_id
* @property {GUID} msid - msid
* @property {string} origin - group_edit_scr
* @property {string} userEntry - bizmngr / site / oneapp
**/
/**
 * Name: Group -> Edit -> Close. Evid: 31.
 * Event description: Group -> Edit -> Save.

 * groupId - Type: guid. Desc: group_id
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: group_edit_scr
 *
 * userEntry - Type: string. Desc: bizmngr / site / oneapp
 * @param {groupEditCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupEditClose = function (params) {
    return { evid: 31, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupOnboardingActionParams
* @property {string} action - close/progress_click/invite/add_cover/update_descr/create_post
* @property {GUID} groupId - group ID
* @property {string} userEntry - bizmgr/site/members_area/oneapp/editor
* @property {boolean} withPimple - true/false
**/
/**
 * Name: Group -> Onboarding Action. Evid: 71.
 * Event description: Group -> Onboarding Action.

 * action - Type: string. Desc: close/progress_click/invite/add_cover/update_descr/create_post
 *
 * groupId - Type: guid. Desc: group ID
 *
 * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp/editor
 *
 * withPimple - Type: bool. Desc: true/false
 * @param {groupOnboardingActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupOnboardingAction = function (params) {
    return { evid: 71, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupGroupRulesRuleActionsParams
* @property {string} action - open/edit/delete
* @property {GUID} groupId - group_id
* @property {string} origin - 1)details_tab_rule_area, 2)details_tab_edit_btn, 3)details_tab_delete_icon
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Group ->  Group Rules - Rule Actions. Evid: 36.
 * Event description: Group ->  Group Rules - Rule Actions.

 * action - Type: string. Desc: open/edit/delete
 *
 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: 1)details_tab_rule_area, 2)details_tab_edit_btn, 3)details_tab_delete_icon
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupGroupRulesRuleActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupGroupRulesRuleActions = function (params) {
    return { evid: 36, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupMembershipQuestionsAddQuestionClickIntentParams
* @property {GUID} groupId - group_id
* @property {string} origin - create_memb_question_scr_cta, memb_qs_scr_plus_btn
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Group ->  Membership Questions - Add Question Click (Intent). Evid: 45.
 * Event description: Group ->  Membership Questions - Add Question Click (Intent).

 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: create_memb_question_scr_cta, memb_qs_scr_plus_btn
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupMembershipQuestionsAddQuestionClickIntentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupMembershipQuestionsAddQuestionClickIntent = function (params) {
    return { evid: 45, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupSelectEventsGroupRestrictionsParams
* @property {GUID} groupId - group ID
* @property {string} groupName - title
* @property {string} origin - create_event_group / manage_event_group
* @property {string} privacy - group privacy - public/private/secret
* @property {string} type - hidden / shown
* @property {string} userEntry - bizmngr/oneapp/site
**/
/**
 * Name: Group -> Save Event Group Settings. Evid: 831.
 * Event description: Group -> Save Event Group Settings.

 * groupId - Type: guid. Desc: group ID
 *
 * groupName - Type: string. Desc: title
 *
 * origin - Type: string. Desc: create_event_group / manage_event_group
 *
 * privacy - Type: string. Desc: group privacy - public/private/secret
 *
 * type - Type: string. Desc: hidden / shown
 *
 * userEntry - Type: string. Desc: bizmngr/oneapp/site
 * @param {groupSelectEventsGroupRestrictionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupSelectEventsGroupRestrictions = function (params) {
    return { evid: 831, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsPageViewParams
* @property {GUID} groupId - guid
* @property {string} origin - explore_groups_button/link/etc...
* @property {string} userEntry - bizmgr/site/members_area/oneapp
* @property {string} viewOn - website / members_app
**/
/**
 * Name: Groups -> Open Groups Page. Evid: 8.
 * Event description: Open Groups Page.

 * groupId - Type: guid. Desc: guid
 *
 * origin - Type: string. Desc: explore_groups_button/link/etc...
 *
 * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp
 *
 * viewOn - Type: string. Desc: website / members_app
 * @param {groupsPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsPageView = function (params) {
    return { evid: 8, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupEditAddEditCoverImageParams
* @property {string} action - add/edit
* @property {GUID} groupId - group_id
* @property {GUID} msid - msid
* @property {string} origin - group_edit_scr_add_img_btn/group_edit_scr_edit_btn
* @property {string} userEntry - bizmngr / site / oneapp
**/
/**
 * Name: Group - Edit - Add / Edit Cover Image. Evid: 32.
 * Event description: Group - Edit - Add /Edit Cover Image.

 * action - Type: string. Desc: add/edit
 *
 * groupId - Type: guid. Desc: group_id
 *
 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: group_edit_scr_add_img_btn/group_edit_scr_edit_btn
 *
 * userEntry - Type: string. Desc: bizmngr / site / oneapp
 * @param {groupEditAddEditCoverImageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupEditAddEditCoverImage = function (params) {
    return { evid: 32, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsAddMemberClickedParams
* @property {GUID} groupId - null
* @property {string} origin - null
* @property {string} pageName - name of initiating page on the site
* @property {string} userEntry - oneapp/site/bizmngr
**/
/**
 * Name: Groups -> add member clicked. Evid: 569.


 * groupId - Type: guid.
 *
 * origin - Type: string.
 *
 * pageName - Type: string. Desc: name of initiating page on the site
 *
 * userEntry - Type: string. Desc: oneapp/site/bizmngr
 * @param {groupsAddMemberClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsAddMemberClicked = function (params) {
    return { evid: 569, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsManageGroups832Params
* @property {string} origin - admin_widget etc
* @property {string} userEntry - oneapp/bizmngr/editor etc
**/
/**
 * Name: Groups -> Manage Groups. Evid: 832.
 * Event description: Groups -> Manage Groups.

 * origin - Type: string. Desc: admin_widget etc
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr/editor etc
 * @param {groupsManageGroups832Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsManageGroups832 = function (params) {
    return { evid: 832, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} ppGroupsButtonClickParams
* @property {string} action - select/unselect/null
* @property {string} buttonName - name of the button
* @property {string} origin - origin
* @property {string} ppID - null
* @property {string} userEntry - bizmngr
**/
/**
 * Name: PP Groups Button Click. Evid: 84.
 * Event description: PP Groups Button Click during creation flow.

 * action - Type: string. Desc: select/unselect/null
 *
 * buttonName - Type: string. Desc: name of the button
 *
 * origin - Type: string. Desc: origin
 *
 * ppID - Type: string.
 *
 * userEntry - Type: string. Desc: bizmngr
 * @param {ppGroupsButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ppGroupsButtonClick = function (params) {
    return { evid: 84, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} clubDeleteClubParams
* @property {GUID} club_id - null
* @property {GUID} clubId - null
* @property {string} userClass - null
**/
/**
 * Name: Club -> delete club. Evid: 167.


 * club_id - Type: guid.
 *
 * clubId - Type: guid.
 *
 * userClass - Type: string.
 * @param {clubDeleteClubParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clubDeleteClub = function (params) {
    return { evid: 167, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsManageAppNotificationsParams
* @property {boolean} commentsToggle - true/false
* @property {GUID} groupId - guid
* @property {boolean} groupNotificationToggle - true/false
* @property {boolean} membersJoinedToggle - true/false
* @property {boolean} newMemberToggle - true/false
* @property {string} origin - group_dashboard
* @property {boolean} postsToggle - true/false
* @property {boolean} reactionsToggle - true/false
* @property {GUID} site_member_id - guid
* @property {string} type - member/owner
* @property {string} userEntry - oneapp
**/
/**
 * Name: Groups-> Manage App Notifications. Evid: 95.
 * Event description: WixApp Groups Notifications.

 * commentsToggle - Type: bool. Desc: true/false
 *
 * groupId - Type: guid. Desc: guid
 *
 * groupNotificationToggle - Type: bool. Desc: true/false
 *
 * membersJoinedToggle - Type: bool. Desc: true/false
 *
 * newMemberToggle - Type: bool. Desc: true/false
 *
 * origin - Type: string. Desc: group_dashboard
 *
 * postsToggle - Type: bool. Desc: true/false
 *
 * reactionsToggle - Type: bool. Desc: true/false
 *
 * site_member_id - Type: guid. Desc: guid
 *
 * type - Type: string. Desc: member/owner
 *
 * userEntry - Type: string. Desc: oneapp
 * @param {groupsManageAppNotificationsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsManageAppNotifications = function (params) {
    return { evid: 95, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsAppSettingsSaveParams
* @property {string} category - layout/settings/display....
* @property {boolean} member_toggle -
* @property {string} origin -
* @property {string} subcategory - image_ratio/title_align...etc
* @property {string} userEntry - bizmgr/site/members_area/oneapp/editor
* @property {string} value - value of subcategory's change
**/
/**
 * Name: Groups -> app settings save. Evid: 20.
 * Event description: groups app settings change and save.

 * category - Type: string. Desc: layout/settings/display....
 *
 * member_toggle - Type: bool.
 *
 * origin - Type: string.
 *
 * subcategory - Type: string. Desc: image_ratio/title_align...etc
 *
 * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp/editor
 *
 * value - Type: string. Desc: value of subcategory's change
 * @param {groupsAppSettingsSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsAppSettingsSave = function (params) {
    return { evid: 20, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupMembershipQuestionsOwnerViewAnswersParams
* @property {GUID} groupId - group_id
* @property {string} memberUuid - member ID
* @property {string} origin - member_questions_screen
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Group ->  Membership Questions - Owner View Answers. Evid: 50.
 * Event description: Group ->  Membership Questions - Owner View Answers.

 * groupId - Type: guid. Desc: group_id
 *
 * memberUuid - Type: string. Desc: member ID
 *
 * origin - Type: string. Desc: member_questions_screen
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupMembershipQuestionsOwnerViewAnswersParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupMembershipQuestionsOwnerViewAnswers = function (params) {
    return { evid: 50, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupCreatePostClickParams
* @property {string} button_name - photo/video/gif/share_something
* @property {GUID} groupId - group_id
* @property {string} origin - top_rce_area/media_tab_btn
* @property {string} userEntry - site/preview
**/
/**
 * Name: Group -> Create Post Click. Evid: 38.
 * Event description: User clicked to create post.

 * button_name - Type: string. Desc: photo/video/gif/share_something
 *
 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: top_rce_area/media_tab_btn
 *
 * userEntry - Type: string. Desc: site/preview
 * @param {groupCreatePostClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupCreatePostClick = function (params) {
    return { evid: 38, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} moderationSettingsClickedParams
* @property {string} groupId - group ID
* @property {string} origin - groups_settings_screen
* @property {string} settings - edit_permissions, 	membership_questions, 	manage_group_rules, 	manage_group_updates,
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Moderation Settings Clicked. Evid: 44.
 * Event description: User clicks one of Moderation Settings buttons.

 * groupId - Type: string. Desc: group ID
 *
 * origin - Type: string. Desc: groups_settings_screen
 *
 * settings - Type: string. Desc: edit_permissions, 	membership_questions, 	manage_group_rules, 	manage_group_updates,
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {moderationSettingsClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var moderationSettingsClicked = function (params) {
    return { evid: 44, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupNotificationsSettingsSaveParams
* @property {boolean} comments - bool
* @property {boolean} emailToggle - bool
* @property {GUID} groupId - id
* @property {boolean} groupUpdates - bool
* @property {boolean} membersJoined - bool
* @property {boolean} mobileAppToggle - bool
* @property {boolean} newMembers - bool
* @property {boolean} posts - bool
* @property {boolean} reactions - bool
* @property {string} tabName - website/email/mobile_app
* @property {string} origin - save_btn
* @property {string} userEntry - site
* @property {boolean} websiteToggle - bool
**/
/**
 * Name: Group - Notifications Settings Save. Evid: 54.
 * Event description: Saves new Notifications settings.

 * comments - Type: bool. Desc: bool
 *
 * emailToggle - Type: bool. Desc: bool
 *
 * groupId - Type: guid. Desc: id
 *
 * groupUpdates - Type: bool. Desc: bool
 *
 * membersJoined - Type: bool. Desc: bool
 *
 * mobileAppToggle - Type: bool. Desc: bool
 *
 * newMembers - Type: bool. Desc: bool
 *
 * posts - Type: bool. Desc: bool
 *
 * reactions - Type: bool. Desc: bool
 *
 * tabName - Type: string. Desc: website/email/mobile_app
 *
 * origin - Type: string. Desc: save_btn
 *
 * userEntry - Type: string. Desc: site
 *
 * websiteToggle - Type: bool. Desc: bool
 * @param {groupNotificationsSettingsSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupNotificationsSettingsSave = function (params) {
    return { evid: 54, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupInvitesClickToInviteMembersFromTheOptionListParams
* @property {string} method - method
* @property {GUID} msid - msid
**/
/**
 * Name: Group -> invites -> click to invite members from the option list. Evid: 409.
 * Event description: When user clicks to invite members from different types of methods: in app invited (other groups, sms, email, etc..) ALSO INCLUDES WIX PROMOTE WHEN SHARING DP INVITE FROM THEIR FLOW.

 * method - Type: string. Desc: method
 *
 * msid - Type: guid. Desc: msid
 * @param {groupInvitesClickToInviteMembersFromTheOptionListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupInvitesClickToInviteMembersFromTheOptionList = function (params) {
    return { evid: 409, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsFeedSelectGroupsSaveParams
* @property {number} groupsCnt - count of connected groups
* @property {string} groupsList - string with comma separated list of connected groupIds
* @property {string} userEntry - site / bizmngr /wixapp
**/
/**
 * Name: Groups Feed - Select Groups - Save. Evid: 826.
 * Event description: Groups Feed - Select Groups - Save.

 * groupsCnt - Type: numeric. Desc: count of connected groups
 *
 * groupsList - Type: string. Desc: string with comma separated list of connected groupIds
 *
 * userEntry - Type: string. Desc: site / bizmngr /wixapp
 * @param {groupsFeedSelectGroupsSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsFeedSelectGroupsSave = function (params) {
    return { evid: 826, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsManageAppEmailNotificationsParams
* @property {boolean} commentsToggle - true/false
* @property {GUID} groupId - guid
* @property {boolean} groupNotificationToggle - true/false
* @property {boolean} membersJoinedToggle - true/false
* @property {string} origin - group_dashboard
* @property {boolean} postsToggle - true/false
* @property {GUID} siteMemberId - guid
* @property {string} type - member/owner
* @property {string} userEntry - oneapp
* @property {boolean} weeklyDigestToggle - null
**/
/**
 * Name: Groups-> Manage App Email Notifications. Evid: 93.
 * Event description: WixApp Groups-> Manage App Email Notifications.

 * commentsToggle - Type: bool. Desc: true/false
 *
 * groupId - Type: guid. Desc: guid
 *
 * groupNotificationToggle - Type: bool. Desc: true/false
 *
 * membersJoinedToggle - Type: bool. Desc: true/false
 *
 * origin - Type: string. Desc: group_dashboard
 *
 * postsToggle - Type: bool. Desc: true/false
 *
 * siteMemberId - Type: guid. Desc: guid
 *
 * type - Type: string. Desc: member/owner
 *
 * userEntry - Type: string. Desc: oneapp
 *
 * weeklyDigestToggle - Type: bool.
 * @param {groupsManageAppEmailNotificationsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsManageAppEmailNotifications = function (params) {
    return { evid: 93, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} showInGroupListParams
* @property {string} origin - group_creation/mobile_group_creation
* @property {boolean} toggle - True/False
* @property {string} userEntry - bizmngr/oneapp
**/
/**
 * Name: Show in Group List. Evid: 81.
 * Event description: Toggle/checkbox to show group in list.

 * origin - Type: string. Desc: group_creation/mobile_group_creation
 *
 * toggle - Type: bool. Desc: True/False
 *
 * userEntry - Type: string. Desc: bizmngr/oneapp
 * @param {showInGroupListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var showInGroupList = function (params) {
    return { evid: 81, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} clubPostOptionsClickDeleteParams
* @property {GUID} club_id - null
* @property {GUID} clubId - null
* @property {string} container - null
* @property {GUID} post_id - null
* @property {GUID} postId - null
* @property {string} type - null
* @property {string} userClass - null
**/
/**
 * Name: Club post -> options -> click delete. Evid: 85.


 * club_id - Type: guid.
 *
 * clubId - Type: guid.
 *
 * container - Type: string.
 *
 * post_id - Type: guid.
 *
 * postId - Type: guid.
 *
 * type - Type: string.
 *
 * userClass - Type: string.
 * @param {clubPostOptionsClickDeleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clubPostOptionsClickDelete = function (params) {
    return { evid: 85, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} clubPostViewPostFullScreenParams
* @property {string} app_id - null
* @property {GUID} club_id - null
* @property {GUID} clubId - null
* @property {string} container - null
* @property {boolean} isPinned - null
* @property {string} origin - groups_my_posts_tab / groups_my_groups_tab
* @property {string} post_id - null
* @property {string} postId - null
* @property {string} type - null
* @property {string} userClass - null
* @property {string} userEntry - bizmngr / site
**/
/**
 * Name: Club post -> view post full screen. Evid: 87.


 * app_id - Type: string.
 *
 * club_id - Type: guid.
 *
 * clubId - Type: guid.
 *
 * container - Type: string.
 *
 * isPinned - Type: bool.
 *
 * origin - Type: string. Desc: groups_my_posts_tab / groups_my_groups_tab
 *
 * post_id - Type: string.
 *
 * postId - Type: string.
 *
 * type - Type: string.
 *
 * userClass - Type: string.
 *
 * userEntry - Type: string. Desc: bizmngr / site
 * @param {clubPostViewPostFullScreenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clubPostViewPostFullScreen = function (params) {
    return { evid: 87, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupFeedTopicsTopicActionsParams
* @property {string} action - open/edit/remove/delete/cancel
* @property {GUID} groupId - group_id
* @property {string} origin - feed_topic_area, edit_qs_scr_three_dots, edit_topic_modal, delete_topic_modal
* @property {string} topicId - topic ID
* @property {string} topicName - topic title
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Group ->  Feed Topics - Topic Actions. Evid: 63.
 * Event description: Group ->  Feed Topics - Topic Actions.

 * action - Type: string. Desc: open/edit/remove/delete/cancel
 *
 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: feed_topic_area, edit_qs_scr_three_dots, edit_topic_modal, delete_topic_modal
 *
 * topicId - Type: string. Desc: topic ID
 *
 * topicName - Type: string. Desc: topic title
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupFeedTopicsTopicActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupFeedTopicsTopicActions = function (params) {
    return { evid: 63, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsTabClickedParams
* @property {GUID} group_id - group_id
* @property {GUID} groupId - group ID
* @property {string} name - tab name
* @property {string} origin - tabs / see_all_members_link / pinned_window
* @property {string} userEntry - site
**/
/**
 * Name: Group -> Group View - Tab Clicked. Evid: 558.
 * Event description: When a user clicks on a tab in the group view.

 * group_id - Type: guid. Desc: group_id
 *
 * groupId - Type: guid. Desc: group ID
 *
 * name - Type: string. Desc: tab name
 *
 * origin - Type: string. Desc: tabs / see_all_members_link / pinned_window
 *
 * userEntry - Type: string. Desc: site
 * @param {groupsTabClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsTabClicked = function (params) {
    return { evid: 558, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupFeedTopicsAddTopicToPostParams
* @property {GUID} groupId - group_id
* @property {string} origin - add_question_scr
* @property {string} postId - ID of the post with topic
* @property {string} topicName - topic name
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Group ->  Feed Topics - Add Topic To Post. Evid: 65.
 * Event description: Group ->  Feed Topics - Add Topic To Post.

 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: add_question_scr
 *
 * postId - Type: string. Desc: ID of the post with topic
 *
 * topicName - Type: string. Desc: topic name
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupFeedTopicsAddTopicToPostParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupFeedTopicsAddTopicToPost = function (params) {
    return { evid: 65, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsSearchMembersClickParams
* @property {GUID} groupId - group ID
* @property {string} membersType - private/public
* @property {string} origin - 'members_list_scr'
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Groups -> Search Members Click. Evid: 59.
 * Event description: Groups -> Search Members Click.

 * groupId - Type: guid. Desc: group ID
 *
 * membersType - Type: string. Desc: private/public
 *
 * origin - Type: string. Desc: 'members_list_scr'
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupsSearchMembersClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsSearchMembersClick = function (params) {
    return { evid: 59, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} joinRestrictedGroupSelectOptionParams
* @property {number} eventId - event_id or null
* @property {string} origin - null
* @property {number} planID - pp_id or null
* @property {string} type - paid_plans/events
* @property {string} userEntry - livesite
**/
/**
 * Name: Join Restricted Group -> Select Option. Evid: 89.


 * eventId - Type: numeric. Desc: event_id or null
 *
 * origin - Type: string.
 *
 * planID - Type: numeric. Desc: pp_id or null
 *
 * type - Type: string. Desc: paid_plans/events
 *
 * userEntry - Type: string. Desc: livesite
 * @param {joinRestrictedGroupSelectOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var joinRestrictedGroupSelectOption = function (params) {
    return { evid: 89, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsSharePostParams
* @property {GUID} group_id - null
* @property {string} origin - null
* @property {string} post_id - null
* @property {string} userClass - null
**/
/**
 * Name: Groups -> Share Post. Evid: 678.


 * group_id - Type: guid.
 *
 * origin - Type: string.
 *
 * post_id - Type: string.
 *
 * userClass - Type: string.
 * @param {groupsSharePostParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsSharePost = function (params) {
    return { evid: 678, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupSettingsOpenParams
* @property {GUID} groupId - group ID
* @property {string} origin - on_group_settings_btn
* @property {string} userEntry - bizmgr/site/members_area/oneapp/editor
* @property {boolean} withPimple - true/false
**/
/**
 * Name: Group -> Settings Click. Evid: 21.
 * Event description: Group settings clicked.

 * groupId - Type: guid. Desc: group ID
 *
 * origin - Type: string. Desc: on_group_settings_btn
 *
 * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp/editor
 *
 * withPimple - Type: bool. Desc: true/false
 * @param {groupSettingsOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupSettingsOpen = function (params) {
    return { evid: 21, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupFeedTopicsTopicListActionsParams
* @property {string} action - sort_recent/sort_name/sort_posts, search, select_all -> delete
* @property {GUID} groupId - group_id
* @property {string} origin - topic_list
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Group ->  Feed Topics - Topic List Actions. Evid: 72.
 * Event description: Group ->  Feed Topics - Topic List Actions (Sort, Search, Select).

 * action - Type: string. Desc: sort_recent/sort_name/sort_posts, search, select_all -> delete
 *
 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: topic_list
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupFeedTopicsTopicListActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupFeedTopicsTopicListActions = function (params) {
    return { evid: 72, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsActionClickedParams
* @property {GUID} groupId - group ID
* @property {GUID} msid - msid
* @property {string} name - name of the action: show/hide/manage/rename/delete
* @property {string} origin - where click happened: example - group_custom_tab_settings
* @property {string} userEntry - oneapp/bizmngr/site
**/
/**
 * Name: Group -> Group Settings/Manage Action Clicked. Evid: 563.
 * Event description: Group -> Group Settings/Manage Action Clicked.

 * groupId - Type: guid. Desc: group ID
 *
 * msid - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: name of the action: show/hide/manage/rename/delete
 *
 * origin - Type: string. Desc: where click happened: example - group_custom_tab_settings
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr/site
 * @param {groupsActionClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsActionClicked = function (params) {
    return { evid: 563, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsSelectAllMembersClickedParams
* @property {string} action - select/unselect
* @property {number} count - count of selected Members
* @property {GUID} groupId - Group ID
* @property {string} membersType - private/public
* @property {string} origin - 'members_list_scr'
* @property {string} userEntry - oneapp/site/bizmngr
**/
/**
 * Name: Groups -> Select All Members Clicked. Evid: 570.
 * Event description: Groups -> Select All Members Clicked.

 * action - Type: string. Desc: select/unselect
 *
 * count - Type: numeric. Desc: count of selected Members
 *
 * groupId - Type: guid. Desc: Group ID
 *
 * membersType - Type: string. Desc: private/public
 *
 * origin - Type: string. Desc: 'members_list_scr'
 *
 * userEntry - Type: string. Desc: oneapp/site/bizmngr
 * @param {groupsSelectAllMembersClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsSelectAllMembersClicked = function (params) {
    return { evid: 570, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsTemplatesPageLoadParams
* @property {string} origin - groups_templates_scr
* @property {string} userEntry - bizmgr/site/editor/oneapp
**/
/**
 * Name: Groups - Templates Page Load. Evid: 35.
 * Event description: When user arrives at the Groups Templates page.

 * origin - Type: string. Desc: groups_templates_scr
 *
 * userEntry - Type: string. Desc: bizmgr/site/editor/oneapp
 * @param {groupsTemplatesPageLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsTemplatesPageLoad = function (params) {
    return { evid: 35, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupAddCustomTabContentParams
* @property {GUID} groupId - group_id
* @property {string} isContentEmpty - true/false
* @property {string} origin - click origin, example add_content_plus_btn
* @property {string} userEntry - oneapp/bizmngr/live site
**/
/**
 * Name: Group ->  Add/Edit Custom Tab Content. Evid: 68.
 * Event description: Group -> Add/Edit Custom Tab Content clicked.

 * groupId - Type: guid. Desc: group_id
 *
 * isContentEmpty - Type: string. Desc: true/false
 *
 * origin - Type: string. Desc: click origin, example add_content_plus_btn
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr/live site
 * @param {groupAddCustomTabContentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupAddCustomTabContent = function (params) {
    return { evid: 68, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupTabsSettingsSaveParams
* @property {GUID} groupId - null
* @property {string} tabOrder - tab order, i.e: "discussion, media, about, etc."
* @property {string} userEntry - null
**/
/**
 * Name: Group Tabs Settings -> Save. Evid: 727.
 * Event description: Group Tabs Settings -> Save clicked.

 * groupId - Type: guid.
 *
 * tabOrder - Type: string. Desc: tab order, i.e: "discussion, media, about, etc."
 *
 * userEntry - Type: string.
 * @param {groupTabsSettingsSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupTabsSettingsSave = function (params) {
    return { evid: 727, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsAddMemberClickDoneParams
* @property {number} count - number of members added
* @property {GUID} groupId - null
* @property {string} membersType - private/public
* @property {string} origin - 'members_list_scr'
* @property {boolean} selectAll - true/false
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Group -> Add Member -> Click Done. Evid: 571.


 * count - Type: numeric. Desc: number of members added
 *
 * groupId - Type: guid.
 *
 * membersType - Type: string. Desc: private/public
 *
 * origin - Type: string. Desc: 'members_list_scr'
 *
 * selectAll - Type: bool. Desc: true/false
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupsAddMemberClickDoneParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsAddMemberClickDone = function (params) {
    return { evid: 571, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} joinRestrictedGroupReadyToJoinParams
* @property {string} origin - go_to_group/join
* @property {string} type - paid_plans/events
* @property {string} userEntry - livesite
**/
/**
 * Name: Join Restricted Group -> Ready To Join. Evid: 91.
 * Event description: Join Restricted Group -> Ready To Join.

 * origin - Type: string. Desc: go_to_group/join
 *
 * type - Type: string. Desc: paid_plans/events
 *
 * userEntry - Type: string. Desc: livesite
 * @param {joinRestrictedGroupReadyToJoinParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var joinRestrictedGroupReadyToJoin = function (params) {
    return { evid: 91, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} reportGroupClickParams
* @property {GUID} group_id - group
* @property {string} origin - report_dialog_modal
* @property {string} type - 'offensive_content'/'spam'/etc
* @property {string} userEntry - site
**/
/**
 * Name: Group page -> report group click. Evid: 7.
 * Event description: report group.

 * group_id - Type: guid. Desc: group
 *
 * origin - Type: string. Desc: report_dialog_modal
 *
 * type - Type: string. Desc: 'offensive_content'/'spam'/etc
 *
 * userEntry - Type: string. Desc: site
 * @param {reportGroupClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var reportGroupClick = function (params) {
    return { evid: 7, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsAboutEditSaveParams
* @property {GUID} groupId - null
* @property {number} length - null
* @property {string} origin - modal_scrn_save_btn
* @property {string} userEntry - site / bizmngr
**/
/**
 * Name: Group - Description - Edit Save. Evid: 560.


 * groupId - Type: guid.
 *
 * length - Type: numeric.
 *
 * origin - Type: string. Desc: modal_scrn_save_btn
 *
 * userEntry - Type: string. Desc: site / bizmngr
 * @param {groupsAboutEditSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsAboutEditSave = function (params) {
    return { evid: 560, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsSelectPricingPlanParams
* @property {GUID} groupId - group ID
* @property {boolean} isVisible - true/false
* @property {string} origin - mobile_group_creation
* @property {string} type - public/private
* @property {string} userEntry - oneapp/bizmngr/site
**/
/**
 * Name: Groups - Select Pricing Plan. Evid: 78.
 * Event description: User clicked on PP link.

 * groupId - Type: guid. Desc: group ID
 *
 * isVisible - Type: bool. Desc: true/false
 *
 * origin - Type: string. Desc: mobile_group_creation
 *
 * type - Type: string. Desc: public/private
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr/site
 * @param {groupsSelectPricingPlanParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsSelectPricingPlan = function (params) {
    return { evid: 78, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} inviteSentParams
* @property {string} contact - e-mail address
* @property {number} count - cnt of members invited
* @property {GUID} group_id - group id
* @property {GUID} groupId - group ID
* @property {string} origin - dialog_scr_invite_btn
* @property {boolean} selectAll - true/false
* @property {GUID} site_member_id - site_member_id
* @property {string} userEntry - bizmngr/site
**/
/**
 * Name: Group -> Invite Members -> Send Invite Done. Evid: 9.
 * Event description: Group -> Invite Members -> Send Invite Done.

 * contact - Type: string. Desc: e-mail address
 *
 * count - Type: numeric. Desc: cnt of members invited
 *
 * group_id - Type: guid. Desc: group id
 *
 * groupId - Type: guid. Desc: group ID
 *
 * origin - Type: string. Desc: dialog_scr_invite_btn
 *
 * selectAll - Type: bool. Desc: true/false
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * userEntry - Type: string. Desc: bizmngr/site
 * @param {inviteSentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var inviteSent = function (params) {
    return { evid: 9, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} inviteMembersClickParams
* @property {GUID} group_id - group
* @property {string} origin - top_pnl_invite_btn / invite_modal_scrn_invite_btn
* @property {string} userEntry - bizmngr / site / etc...
**/
/**
 * Name: Group -> invite members click. Evid: 25.
 * Event description: clicked invite members.

 * group_id - Type: guid. Desc: group
 *
 * origin - Type: string. Desc: top_pnl_invite_btn / invite_modal_scrn_invite_btn
 *
 * userEntry - Type: string. Desc: bizmngr / site / etc...
 * @param {inviteMembersClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var inviteMembersClick = function (params) {
    return { evid: 25, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} memberTabAdminActionClickParams
* @property {string} action - remove_admin/remove_member/set_admin
* @property {GUID} group_id - group_id
* @property {string} origin - member_tab_member_option_clk
* @property {GUID} site_member_id - member
* @property {string} userEntry - site / bizmngr
**/
/**
 * Name: Group -> member tab admin action click. Evid: 14.
 * Event description: admin actions in member tab (3 dots).

 * action - Type: string. Desc: remove_admin/remove_member/set_admin
 *
 * group_id - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: member_tab_member_option_clk
 *
 * site_member_id - Type: guid. Desc: member
 *
 * userEntry - Type: string. Desc: site / bizmngr
 * @param {memberTabAdminActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var memberTabAdminActionClick = function (params) {
    return { evid: 14, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupSettingsSelectSettingsAreaFromListParams
* @property {GUID} groupId - group ID
* @property {string} name - Settings area name
* @property {string} origin - manage_tab/ null for add_on settings
**/
/**
 * Name: Group -> Settings -> Select Settings area from list. Evid: 572.


 * groupId - Type: guid. Desc: group ID
 *
 * name - Type: string. Desc: Settings area name
 *
 * origin - Type: string. Desc: manage_tab/ null for add_on settings
 * @param {groupSettingsSelectSettingsAreaFromListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupSettingsSelectSettingsAreaFromList = function (params) {
    return { evid: 572, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupListSettingsOpenParams
* @property {string} origin - origin
* @property {string} userEntry - bizmgr/site/members_area/oneapp/editor
**/
/**
 * Name: Group -> list settings open. Evid: 16.
 * Event description: user opened group list settings.

 * origin - Type: string. Desc: origin
 *
 * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp/editor
 * @param {groupListSettingsOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupListSettingsOpen = function (params) {
    return { evid: 16, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsSelectCommentTemplateClickParams
* @property {GUID} groupId - group_id
* @property {string} origin - feed_list/post
* @property {string} template - template name
* @property {string} type - template type
* @property {string} userEntry - site/preview/oneapp
**/
/**
 * Name: Groups - Select Comment Template Click. Evid: 39.
 * Event description: User clicked on comment template in Feed.

 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: feed_list/post
 *
 * template - Type: string. Desc: template name
 *
 * type - Type: string. Desc: template type
 *
 * userEntry - Type: string. Desc: site/preview/oneapp
 * @param {groupsSelectCommentTemplateClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsSelectCommentTemplateClick = function (params) {
    return { evid: 39, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} forsaleNewForsalePostCreatedParams
* @property {GUID} clubId - null
* @property {string} container - null
* @property {string} currency - null
* @property {string} origin - null
* @property {GUID} postId - null
* @property {number} price - null
* @property {GUID} saleItemId - null
* @property {string} userClass - null
* @property {boolean} withPhoto - null
**/
/**
 * Name: Forsale -> new forsale post created. Evid: 483.


 * clubId - Type: guid.
 *
 * container - Type: string.
 *
 * currency - Type: string.
 *
 * origin - Type: string.
 *
 * postId - Type: guid.
 *
 * price - Type: numeric.
 *
 * saleItemId - Type: guid.
 *
 * userClass - Type: string.
 *
 * withPhoto - Type: bool.
 * @param {forsaleNewForsalePostCreatedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var forsaleNewForsalePostCreated = function (params) {
    return { evid: 483, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsChangedDefaultSortParams
* @property {string} sort_by - null
**/
/**
 * Name: Groups: changed default sort. Evid: 822.


 * sort_by - Type: string.
 * @param {groupsChangedDefaultSortParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsChangedDefaultSort = function (params) {
    return { evid: 822, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupEditGroupDescriptionParams
* @property {string} action - report / cancel
* @property {string} container - groups/ events
* @property {GUID} groupId - group ID
* @property {GUID} postId - post ID
* @property {string} userClass - owner / member
**/
/**
 * Name: Group Post -> Options -> Report action. Evid: 70.
 * Event description: Group Post -> options -> Report action from Report modal (Report/Cancel).

 * action - Type: string. Desc: report / cancel
 *
 * container - Type: string. Desc: groups/ events
 *
 * groupId - Type: guid. Desc: group ID
 *
 * postId - Type: guid. Desc: post ID
 *
 * userClass - Type: string. Desc: owner / member
 * @param {groupEditGroupDescriptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupEditGroupDescription = function (params) {
    return { evid: 70, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} showGroupDetailsUpdateToggleParams
* @property {string} origin - null
* @property {boolean} toggle - true/false
* @property {string} userEntry - null
**/
/**
 * Name: Show Group Details Update Toggle. Evid: 42.
 * Event description: Show Group Details Update Toggle.

 * origin - Type: string.
 *
 * toggle - Type: bool. Desc: true/false
 *
 * userEntry - Type: string.
 * @param {showGroupDetailsUpdateToggleParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var showGroupDetailsUpdateToggle = function (params) {
    return { evid: 42, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupShareSomethingClickParams
* @property {GUID} msid - msid
* @property {string} origin - null
* @property {string} userEntry - null
**/
/**
 * Name: Group -> Share Something Click. Evid: 96.


 * msid - Type: guid. Desc: msid
 *
 * origin - Type: string.
 *
 * userEntry - Type: string.
 * @param {groupShareSomethingClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupShareSomethingClick = function (params) {
    return { evid: 96, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsIntegrationSelectWhichGroupToConnectParams
* @property {GUID} event_id - ID
* @property {GUID} groupId - group ID
* @property {string} origin - group list
* @property {string} ppID - paid plan id
* @property {string} userEntry - bizmgr/site/members_area/oneapp
**/
/**
 * Name: Groups Integration -> Select which group to connect. Evid: 67.
 * Event description: When user clicks on groups list to select which group to connect to challenge etc..

 * event_id - Type: guid. Desc: ID
 *
 * groupId - Type: guid. Desc: group ID
 *
 * origin - Type: string. Desc: group list
 *
 * ppID - Type: string. Desc: paid plan id
 *
 * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp
 * @param {groupsIntegrationSelectWhichGroupToConnectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsIntegrationSelectWhichGroupToConnect = function (params) {
    return { evid: 67, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsMemberRequestToCreateAGroupApproveDeclineParams
* @property {string} actionType - approve / decline
* @property {GUID} groupId - value
* @property {boolean} isAll - Decline or approve all true / false
* @property {GUID} memberId - value
* @property {string} memberUuid - member ID
* @property {string} origin - user_lvl_btn
* @property {string} userEntry - bizmgr/site/ null if oneapp
**/
/**
 * Name: Groups -> member request to create a group -> approve / decline. Evid: 26.
 * Event description: Groups -> member request to create a group -> approve / decline.

 * actionType - Type: string. Desc: approve / decline
 *
 * groupId - Type: guid. Desc: value
 *
 * isAll - Type: bool. Desc: Decline or approve all true / false
 *
 * memberId - Type: guid. Desc: value
 *
 * memberUuid - Type: string. Desc: member ID
 *
 * origin - Type: string. Desc: user_lvl_btn
 *
 * userEntry - Type: string. Desc: bizmgr/site/ null if oneapp
 * @param {groupsMemberRequestToCreateAGroupApproveDeclineParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsMemberRequestToCreateAGroupApproveDecline = function (params) {
    return { evid: 26, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupFeedTopicsCreateTopicParams
* @property {GUID} groupId - group_id
* @property {string} origin - add_question_scr
* @property {string} topicId - topic ID
* @property {number} topicLength - count of characters in the topic name
* @property {string} topicName - topic name/ JSON
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Group ->  Feed Topics - Create Topic. Evid: 62.
 * Event description: Group ->  Feed Topics - Create Topic.

 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: add_question_scr
 *
 * topicId - Type: string. Desc: topic ID
 *
 * topicLength - Type: numeric. Desc: count of characters in the topic name
 *
 * topicName - Type: string. Desc: topic name/ JSON
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupFeedTopicsCreateTopicParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupFeedTopicsCreateTopic = function (params) {
    return { evid: 62, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} postActionClickParams
* @property {string} action - 'delete'/'edit'/'share'/'follow'/'pin'
* @property {string} container - groups/events
* @property {GUID} group_id - group id
* @property {GUID} groupId - group ID
* @property {string} origin - three_dots_menu
* @property {string} post_id - post_id
* @property {string} postId - null
* @property {string} userClass - owner/member
* @property {string} userEntry - site
**/
/**
 * Name: Post Action Click. Evid: 3.
 * Event description: user clicked post action from three dots.

 * action - Type: string. Desc: 'delete'/'edit'/'share'/'follow'/'pin'
 *
 * container - Type: string. Desc: groups/events
 *
 * group_id - Type: guid. Desc: group id
 *
 * groupId - Type: guid. Desc: group ID
 *
 * origin - Type: string. Desc: three_dots_menu
 *
 * post_id - Type: string. Desc: post_id
 *
 * postId - Type: string.
 *
 * userClass - Type: string. Desc: owner/member
 *
 * userEntry - Type: string. Desc: site
 * @param {postActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var postActionClick = function (params) {
    return { evid: 3, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsFeedClickOnGroupListParams
* @property {number} groupsCnt - count of connected groups
* @property {string} groupsList - string with comma separated list of connected groupIds
* @property {string} origin - my_groups_carousel etc
* @property {string} userEntry - site / bizmngr /wixapp
**/
/**
 * Name: Groups Feed - Click on Group List. Evid: 827.
 * Event description: Groups Feed - Click on Group List.

 * groupsCnt - Type: numeric. Desc: count of connected groups
 *
 * groupsList - Type: string. Desc: string with comma separated list of connected groupIds
 *
 * origin - Type: string. Desc: my_groups_carousel etc
 *
 * userEntry - Type: string. Desc: site / bizmngr /wixapp
 * @param {groupsFeedClickOnGroupListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsFeedClickOnGroupList = function (params) {
    return { evid: 827, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsRenameTabClickSaveParams
* @property {GUID} groupId - null
* @property {string} name - null
**/
/**
 * Name: Groups -> rename tab -> click save. Evid: 573.


 * groupId - Type: guid.
 *
 * name - Type: string.
 * @param {groupsRenameTabClickSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsRenameTabClickSave = function (params) {
    return { evid: 573, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupMembershipQuestionsMembershipQuestionsSavedParams
* @property {number} countQuestions - null
* @property {GUID} groupId - group_id
* @property {string} origin - add_question_scr
* @property {string} questionsArray - JSON with all questions and is_required attribute
* @property {string} userEntry - null
**/
/**
 * Name: Group ->  Membership Questions - Membership Questions Saved. Evid: 52.
 * Event description: Group ->  Membership Questions - Membership Questions Saved.

 * countQuestions - Type: numeric.
 *
 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: add_question_scr
 *
 * questionsArray - Type: string. Desc: JSON with all questions and is_required attribute
 *
 * userEntry - Type: string.
 * @param {groupMembershipQuestionsMembershipQuestionsSavedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupMembershipQuestionsMembershipQuestionsSaved = function (params) {
    return { evid: 52, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} clubPostAddPhotoParams
* @property {GUID} club_id - null
* @property {GUID} clubId - null
* @property {string} container - null
* @property {string} origin - null
* @property {GUID} postId - null
* @property {string} userClass - null
**/
/**
 * Name: Club post -> add photo. Evid: 80.


 * club_id - Type: guid.
 *
 * clubId - Type: guid.
 *
 * container - Type: string.
 *
 * origin - Type: string.
 *
 * postId - Type: guid.
 *
 * userClass - Type: string.
 * @param {clubPostAddPhotoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clubPostAddPhoto = function (params) {
    return { evid: 80, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupCustomTabSaveParams
* @property {number} filesCnt - number of files
* @property {GUID} groupId - group_id
* @property {number} imgCnt - number of images
* @property {number} linksCnt - number of links
* @property {string} tabDescription - tab description (full text)
* @property {string} tabName - tab name
* @property {string} userEntry - oneapp/bizmngr
* @property {number} videosCnt - number of videos
**/
/**
 * Name: Group ->  Custom Tab Save. Evid: 69.
 * Event description: Group ->  Custom Tab Save Clicked.

 * filesCnt - Type: numeric. Desc: number of files
 *
 * groupId - Type: guid. Desc: group_id
 *
 * imgCnt - Type: numeric. Desc: number of images
 *
 * linksCnt - Type: numeric. Desc: number of links
 *
 * tabDescription - Type: string. Desc: tab description (full text)
 *
 * tabName - Type: string. Desc: tab name
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 *
 * videosCnt - Type: numeric. Desc: number of videos
 * @param {groupCustomTabSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupCustomTabSave = function (params) {
    return { evid: 69, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsFeedClickSeeAllParams
* @property {string} userEntry - site / bizmngr /wixapp
**/
/**
 * Name: Groups Feed - Click See All. Evid: 828.
 * Event description: Groups Feed - Click See All in unified feed.

 * userEntry - Type: string. Desc: site / bizmngr /wixapp
 * @param {groupsFeedClickSeeAllParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsFeedClickSeeAll = function (params) {
    return { evid: 828, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsCreateSaveParams
* @property {number} countMembersAdded - null
* @property {string} origin - null
* @property {string} type - null
* @property {boolean} withPhoto - null
**/
/**
 * Name: Groups -> Create -> Save. Evid: 557.


 * countMembersAdded - Type: numeric.
 *
 * origin - Type: string.
 *
 * type - Type: string.
 *
 * withPhoto - Type: bool.
 * @param {groupsCreateSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsCreateSave = function (params) {
    return { evid: 557, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsSelectGroupOptionParams
* @property {string} option - admin_approval / monetize. public / private
* @property {string} origin - plus_button_new
* @property {string} type - privacy/ access
* @property {string} userEntry - oneapp
**/
/**
 * Name: Groups -> Select Group Option. Evid: 835.
 * Event description: select group options (privacy, access) during group creation on mobile.

 * option - Type: string. Desc: admin_approval / monetize. public / private
 *
 * origin - Type: string. Desc: plus_button_new
 *
 * type - Type: string. Desc: privacy/ access
 *
 * userEntry - Type: string. Desc: oneapp
 * @param {groupsSelectGroupOptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsSelectGroupOption = function (params) {
    return { evid: 835, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsOpenGroupSettingsBmParams
* @property {GUID} groupId - group iD
* @property {string} origin - group_area, three_dots
* @property {string} userEntry - bizmngr
**/
/**
 * Name: Groups -> Open Group Settings (BM). Evid: 2.
 * Event description: Groups -> Open Group Settings from Group List in BM.

 * groupId - Type: guid. Desc: group iD
 *
 * origin - Type: string. Desc: group_area, three_dots
 *
 * userEntry - Type: string. Desc: bizmngr
 * @param {groupsOpenGroupSettingsBmParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsOpenGroupSettingsBm = function (params) {
    return { evid: 2, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsFeedInviteMembersParams
* @property {GUID} groupId - group ID
* @property {string} origin - groups onboarding
* @property {string} userClass - owner/member
* @property {string} userEntry - oneapp/bizmngr/site
**/
/**
 * Name: Groups Feed -> Invite Members. Evid: 679.
 * Event description: The event is triggered when a user presses the share button (either from the share button or the post header) in the groups feed..

 * groupId - Type: guid. Desc: group ID
 *
 * origin - Type: string. Desc: groups onboarding
 *
 * userClass - Type: string. Desc: owner/member
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr/site
 * @param {groupsFeedInviteMembersParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsFeedInviteMembers = function (params) {
    return { evid: 679, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsChangeTabsOrderParams
* @property {string} groupId - group_id
* @property {string} tabName - tabName
* @property {string} userEntry - site / bizmngr
**/
/**
 * Name: Groups -> Change tabs order. Evid: 825.
 * Event description: reorder tabs in a group and bring the most important ones to the beginning.

 * groupId - Type: string. Desc: group_id
 *
 * tabName - Type: string. Desc: tabName
 *
 * userEntry - Type: string. Desc: site / bizmngr
 * @param {groupsChangeTabsOrderParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsChangeTabsOrder = function (params) {
    return { evid: 825, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsManageTabsWixAppParams
* @property {GUID} group_id - null
* @property {GUID} msid - null
* @property {string} name - tab name
**/
/**
 * Name: Groups -> Manage Tabs - WixApp. Evid: 753.


 * group_id - Type: guid.
 *
 * msid - Type: guid.
 *
 * name - Type: string. Desc: tab name
 * @param {groupsManageTabsWixAppParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsManageTabsWixApp = function (params) {
    return { evid: 753, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsTemplatesCloseParams
* @property {string} origin - groups_templates_scr
* @property {string} userEntry - bizmgr/site/editor/oneapp
**/
/**
 * Name: Groups-> Templates - Close. Evid: 34.
 * Event description: When user closes the Templates page.

 * origin - Type: string. Desc: groups_templates_scr
 *
 * userEntry - Type: string. Desc: bizmgr/site/editor/oneapp
 * @param {groupsTemplatesCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsTemplatesClose = function (params) {
    return { evid: 34, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} changeGroupPageDisplayParams
* @property {string} category - layout/display...
* @property {GUID} group_id - group
* @property {string} info - member_count/group_list_title/etc
* @property {string} origin - on_fly
* @property {string} subcategory - discussions/media....
* @property {string} userEntry - editor
* @property {string} value - value of the subcategory that changed
**/
/**
 * Name: Group -> page settings save. Evid: 22.
 * Event description: changed list display.

 * category - Type: string. Desc: layout/display...
 *
 * group_id - Type: guid. Desc: group
 *
 * info - Type: string. Desc: member_count/group_list_title/etc
 *
 * origin - Type: string. Desc: on_fly
 *
 * subcategory - Type: string. Desc: discussions/media....
 *
 * userEntry - Type: string. Desc: editor
 *
 * value - Type: string. Desc: value of the subcategory that changed
 * @param {changeGroupPageDisplayParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var changeGroupPageDisplay = function (params) {
    return { evid: 22, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupGroupRulesCreateRuleClickIntentParams
* @property {string} fromRuleTemplate - template name, number or other characteristics if from template, null if own rule (not from template)
* @property {GUID} groupId - group_id
* @property {string} origin - create_rule_scr
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Group ->  Group Rules - Create Rule Click (Intent). Evid: 28.
 * Event description: Group ->  Group Rules - Create Rule Click (Intent).

 * fromRuleTemplate - Type: string. Desc: template name, number or other characteristics if from template, null if own rule (not from template)
 *
 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: create_rule_scr
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupGroupRulesCreateRuleClickIntentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupGroupRulesCreateRuleClickIntent = function (params) {
    return { evid: 28, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsWelcomeToGroupsScreenClickParams
* @property {string} action - get_started/back
* @property {string} userEntry - oneapp
**/
/**
 * Name: Groups - Welcome to Groups Screen Click. Evid: 56.
 * Event description: Groups - Welcome to Groups Screen Click.

 * action - Type: string. Desc: get_started/back
 *
 * userEntry - Type: string. Desc: oneapp
 * @param {groupsWelcomeToGroupsScreenClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsWelcomeToGroupsScreenClick = function (params) {
    return { evid: 56, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsEditClickedParams
* @property {GUID} groupId - null
* @property {string} origin - group settings / onboarding
* @property {string} userEntry - bizmngr / site / oneapp
**/
/**
 * Name: Groups -> edit clicked. Evid: 568.


 * groupId - Type: guid.
 *
 * origin - Type: string. Desc: group settings / onboarding
 *
 * userEntry - Type: string. Desc: bizmngr / site / oneapp
 * @param {groupsEditClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsEditClicked = function (params) {
    return { evid: 568, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsBoLoadedParams
* @property {string} origin - pnl_manage_groups_btn / settings_pnl_manage_groups_btn / on_group_manage_groups_btn / bo_groups_btn
* @property {string} userEntry - bizmgr/site/members_area/oneapp/editor
**/
/**
 * Name: Groups -> Open Groups BO (Web). Evid: 17.
 * Event description: backoffice loaded.

 * origin - Type: string. Desc: pnl_manage_groups_btn / settings_pnl_manage_groups_btn / on_group_manage_groups_btn / bo_groups_btn
 *
 * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp/editor
 * @param {groupsBoLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsBoLoaded = function (params) {
    return { evid: 17, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupMembershipQuestionsQuestionActionsParams
* @property {string} action - open/edit/remove/delete/cancel
* @property {GUID} groupId - group_id
* @property {string} origin - edit_qs_scr_question_area, edit_qs_scr_three_dots, edit_question_modal, delete_question_modal
* @property {string} questionId - question ID
* @property {number} questionIndex - q index
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Group ->  Membership Questions - Question Actions. Evid: 47.
 * Event description: Group ->  Membership Questions - Question Actions.

 * action - Type: string. Desc: open/edit/remove/delete/cancel
 *
 * groupId - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: edit_qs_scr_question_area, edit_qs_scr_three_dots, edit_question_modal, delete_question_modal
 *
 * questionId - Type: string. Desc: question ID
 *
 * questionIndex - Type: numeric. Desc: q index
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupMembershipQuestionsQuestionActionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupMembershipQuestionsQuestionActions = function (params) {
    return { evid: 47, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} clubPostOptionsEditEditSavedParams
* @property {GUID} club_id - null
* @property {GUID} clubId - null
* @property {string} container - null
* @property {string} post_id - null
* @property {string} postId - null
* @property {GUID} postItemId - null
* @property {string} userClass - null
**/
/**
 * Name: Club post -> options --> edit -> edit saved. Evid: 146.


 * club_id - Type: guid.
 *
 * clubId - Type: guid.
 *
 * container - Type: string.
 *
 * post_id - Type: string.
 *
 * postId - Type: string.
 *
 * postItemId - Type: guid.
 *
 * userClass - Type: string.
 * @param {clubPostOptionsEditEditSavedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clubPostOptionsEditEditSaved = function (params) {
    return { evid: 146, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsSelectGroupTemplateClickParams
* @property {string} origin - groups_templates_scr
* @property {string} templateId - template id
* @property {string} templateName - staff/education/family/vips/meetup/hobby or custom_group if from Create Custom button
* @property {string} userEntry - bizmgr/site/editor/oneapp
**/
/**
 * Name: Groups -> Select Group Template Click. Evid: 37.
 * Event description: Groups -> Select Group Template Click.

 * origin - Type: string. Desc: groups_templates_scr
 *
 * templateId - Type: string. Desc: template id
 *
 * templateName - Type: string. Desc: staff/education/family/vips/meetup/hobby or custom_group if from Create Custom button
 *
 * userEntry - Type: string. Desc: bizmgr/site/editor/oneapp
 * @param {groupsSelectGroupTemplateClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsSelectGroupTemplateClick = function (params) {
    return { evid: 37, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupActionClickParams
* @property {string} action - 'share'/'group_settings'/'report'/'leave'/'delete'/'notification_settings'
* @property {GUID} group_id - group_id
* @property {string} origin - arrow / menu / button / modal_dialog_button
* @property {string} userEntry - site / bizmngr / null if wixapp
**/
/**
 * Name: Groups -> Group Action Click. Evid: 4.
 * Event description: Clicked on Group action (from three dots).

 * action - Type: string. Desc: 'share'/'group_settings'/'report'/'leave'/'delete'/'notification_settings'
 *
 * group_id - Type: guid. Desc: group_id
 *
 * origin - Type: string. Desc: arrow / menu / button / modal_dialog_button
 *
 * userEntry - Type: string. Desc: site / bizmngr / null if wixapp
 * @param {groupActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupActionClick = function (params) {
    return { evid: 4, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsRequestJoinAGroupParams
* @property {string} approvalStatus - status of member upon request
* @property {GUID} groupId - null
* @property {GUID} group_id - value
* @property {string} origin - group_feed_top_banner_btn / group_feed_inside_page_btn
* @property {string} type - null
* @property {string} userEntry - site / bizmngr
**/
/**
 * Name: Groups -> request / join a group. Evid: 564.


 * approvalStatus - Type: string. Desc: status of member upon request
 *
 * groupId - Type: guid.
 *
 * group_id - Type: guid. Desc: value
 *
 * origin - Type: string. Desc: group_feed_top_banner_btn / group_feed_inside_page_btn
 *
 * type - Type: string.
 *
 * userEntry - Type: string. Desc: site / bizmngr
 * @param {groupsRequestJoinAGroupParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsRequestJoinAGroup = function (params) {
    return { evid: 564, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} newEventCreateYourGroupPageLoadParams
* @property {GUID} msid - msid
**/
/**
 * Name: Groups->Create your group page load. Evid: 780.
 * Event description: user is viewing create your group page (with form to fill).

 * msid - Type: guid. Desc: msid
 * @param {newEventCreateYourGroupPageLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var newEventCreateYourGroupPageLoad = function (params) {
    return { evid: 780, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsSelectMemberInMembersListParams
* @property {GUID} groupId - group ID
* @property {string} membersType - private/public
* @property {string} origin - 'members_list_scr'
* @property {string} userEntry - oneapp/bizmngr
**/
/**
 * Name: Groups -> Select Member in Members List. Evid: 60.
 * Event description: Groups -> Select Member in Members List.

 * groupId - Type: guid. Desc: group ID
 *
 * membersType - Type: string. Desc: private/public
 *
 * origin - Type: string. Desc: 'members_list_scr'
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr
 * @param {groupsSelectMemberInMembersListParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsSelectMemberInMembersList = function (params) {
    return { evid: 60, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupGroupEventsButtonClicksParams
* @property {string} buttonName - create_event, discard/back, save
* @property {number} count - # of events with checks on “save”
* @property {GUID} groupId - group ID
* @property {string} name - Settings area name
* @property {string} origin - group_events_list, group_events_empty_state
* @property {string} userEntry - oneapp/bizmngr/site
**/
/**
 * Name: Group -> Group Events Button Clicks. Evid: 58.
 * Event description: Group -> Group Events Button Clicks.

 * buttonName - Type: string. Desc: create_event, discard/back, save
 *
 * count - Type: numeric. Desc: # of events with checks on “save”
 *
 * groupId - Type: guid. Desc: group ID
 *
 * name - Type: string. Desc: Settings area name
 *
 * origin - Type: string. Desc: group_events_list, group_events_empty_state
 *
 * userEntry - Type: string. Desc: oneapp/bizmngr/site
 * @param {groupGroupEventsButtonClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupGroupEventsButtonClicks = function (params) {
    return { evid: 58, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsFeedClickExitFromUnifiedFeedParams
* @property {string} userEntry - site / bizmngr /wixapp
**/
/**
 * Name: Groups Feed - Click Exit from Unified Feed. Evid: 829.
 * Event description: Groups Feed - Click Exit from Unified Feed.

 * userEntry - Type: string. Desc: site / bizmngr /wixapp
 * @param {groupsFeedClickExitFromUnifiedFeedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsFeedClickExitFromUnifiedFeed = function (params) {
    return { evid: 829, src: 111, endpoint: 'groups', params: params };
};
/**
* @typedef {Object} groupsEmptyStateClickParams
* @property {string} buttonName - contact_owner
* @property {string} origin - group_feed_empty_state
* @property {string} userEntry - wixapp
**/
/**
 * Name: Groups -> Empty State Click. Evid: 94.
 * Event description: Groups -> Empty State Click.

 * buttonName - Type: string. Desc: contact_owner
 *
 * origin - Type: string. Desc: group_feed_empty_state
 *
 * userEntry - Type: string. Desc: wixapp
 * @param {groupsEmptyStateClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var groupsEmptyStateClick = function (params) {
    return { evid: 94, src: 111, endpoint: 'groups', params: params };
};
//# sourceMappingURL=index.js.map